export default function reportScheduleDirective() {
  return {
    template: require('./report-schedule.html'),
    controller: 'SRReportScheduleController',
    controllerAs: 'srReportScheduleVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportSchedule: '=',
    },
  };
}
